(() => {
  if (window.__CARD_VARIANT_PILLS_BOUND__) return;
  window.__CARD_VARIANT_PILLS_BOUND__ = true;

  // 値のゆらぎ吸収（全角/半角・前後空白）
  const norm = (v) => (v == null ? '' : String(v).trim().normalize('NFKC'));

  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.cvp-pill');
    if (!pill) return;

    // ストレッチリンク対策
    e.preventDefault();
    e.stopPropagation();

    const group  = pill.closest('.cvp-group');
    const picker = pill.closest('.card-variant-picker');
    const form   = pill.closest('form.card-atc-form');
    if (!group || !picker || !form) return;

    // 1) 見た目の選択状態更新
    group.querySelectorAll('.cvp-pill[aria-pressed="true"]').forEach(b => b.setAttribute('aria-pressed', 'false'));
    pill.setAttribute('aria-pressed', 'true');

    // 2) variant-map を読む
    const mapEl = form.querySelector('.variant-map');
    if (!mapEl) {
      return;
    }

    let payload;
    try {
      payload = JSON.parse(mapEl.textContent || '{}');
    } catch (err) {
      return;
    }
    const variants = payload.variants || [];
    const options  = payload.options  || [];

    // 3) 現在の選択を options の順で配列化
    const selected = options.map((_, idx) => {
      const pressed = picker.querySelector(`.cvp-group[data-option-index="${idx}"] .cvp-pill[aria-pressed="true"]`);
      return pressed ? norm(pressed.dataset.value) : null;
    });

    const submitBtn = form.querySelector('[data-role="card-atc-submit"]') || form.querySelector('button[type="submit"]');
    const idInput   = form.querySelector('.product-variant-id');

    // 未選択がある場合は無効化
    if (!idInput || !submitBtn || selected.some(v => v === null)) {
      submitBtn?.setAttribute('disabled', 'disabled');
      if (idInput) idInput.value = '';
      return;
    }

    // 4) 一致バリアント探索（正規化して比較）
    const match = variants.find(v => {
      const opts = (v?.options || []).map(norm);
      if (opts.length !== selected.length) return false;
      for (let i = 0; i < selected.length; i++) {
        if (opts[i] !== selected[i]) return false;
      }
      return true;
    });

    if (match) {
      idInput.value = match.id;
      if (match.available === true) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
      }
    } else {
      idInput.value = '';
      submitBtn.setAttribute('disabled', 'disabled');
    }
  });
})();